'use client';

import { useRefinementList, UseRefinementListProps } from 'react-instantsearch';
import { cn } from '@/app/lib';
import { TagButton } from '@workspace/ui/common/TagFilter/TagButton';

type TagRefinementsProps = UseRefinementListProps & {
  className?: string;
  classNames?: {
    button?: string;
    selectedButton?: string;
    disabledButton?: string;
  };
};

export function TagRefinements({ className, classNames, ...props }: TagRefinementsProps) {
  const { canRefine, items, refine } = useRefinementList(props, {
    $$widgetType: 'ais.refinementList',
  });

  // Check if any filter is active
  const hasActiveFilters = items.some((item) => item.isRefined);

  // Handle clearing all filters
  const handleClearAll = () => {
    items.forEach((item) => {
      if (item.isRefined) {
        refine(item.value);
      }
    });
  };

  return (
    <div className={cn('flex flex-wrap gap-xs', className)}>
      {/* All tag - always displayed first */}
      <TagButton
        label="All"
        isSelected={!hasActiveFilters}
        isDisabled={!canRefine}
        onClick={handleClearAll}
        classNames={classNames}
      />

      {items.map((item) => (
        <TagButton
          key={item.value}
          label={item.label}
          isSelected={item.isRefined}
          isDisabled={!canRefine}
          onClick={() => refine(item.value)}
          classNames={classNames}
        />
      ))}
    </div>
  );
}
